import React, { Component } from 'react';
import {Link} from 'react-router-dom'

class TabCourses extends Component {
    render() {
        return (
            <div className="flat-tabs">
                <ul className="tab-title clearfix style4">
                    <li className="item-title  overview">
                        <span className="inner">FACILITY</span>
                    </li>
                    <li className="item-title event">
                        <span className="inner">E-LEARNING</span>
                    </li>
                    <li className="item-title requirements">
                        <span className="inner">VOVABULARY</span>
                    </li>
                    <li className="item-title review">
                        <span className="inner">KID'S COURSES</span>
                    </li>
                </ul>
                <div className="tab-content-wrap">
                    <div className="tab-content ">
                        <div className="item-content">
                            <div className="text-wrap img-right clearfix">
                                <div className="video flat-text-center">
                                    <img src="images/register/video.png" alt="bookflare" />
                                    <a data-type="iframe" href="https://www.youtube.com/embed/2Ge1GGitzLw?autoplay=1"
                                        className=" fancybox"><span className="icon-video" /></a>
                                </div>
                                <h6 className="title">
                                    Limitless Learning Possibilities
                                </h6>
                                <p className="text">Lorem Ipsn gravida nibh vel velit auctor aliquet. Aenean sollicitudin, lorem
                                    quis bibendum auci elit consequat ipsutis sem nibh id elit. Duis sed odio sit amet nibh
                                    vulputate cursus a sit amet mauris. Morbi accumsan ipsum velit. Nam nec tellus a odio tincidunt
                                    aucto.</p>
                                <h6 className="title mg-bottom-25">
                                    REQUIREMENTS
                                </h6>
                                <p className="text">Per inceptos himenaeos. Mauris in erat justo. Nullam ac urna eu felis dapibus
                                    condntum sit amet a augue. Sed non mauris vitae erat consequat auctor eu in elit. Class aptento
                                    taciti sociosqu ad litora torquent.</p>
                            </div>
                        </div>
                    </div>
                    <div className="tab-content ">
                        <div className="item-content">
                            <div className="text-wrap img-right clearfix">
                                <div className="video flat-text-center">
                                    <img src="images/register/video.png" alt="bookflare" />
                                    <a data-type="iframe" href="https://www.youtube.com/embed/2Ge1GGitzLw?autoplay=1"
                                        className=" fancybox"><span className="icon-video" /></a>
                                </div>
                                <h6 className="title">
                                    E-LEARNING
                                </h6>
                                <p className="text">Lorem Ipsn gravida nibh vel velit auctor aliquet. Aenean sollicitudin, lorem
                                    quis bibendum auci elit consequat ipsutis sem nibh id elit. Duis sed odio sit amet nibh
                                    vulputate cursus a sit amet mauris. Morbi accumsan ipsum velit. Nam nec tellus a odio tincidunt
                                    aucto.</p>
                                <h6 className="title mg-bottom-25">
                                    REQUIREMENTS
                                </h6>
                                <p className="text">Per inceptos himenaeos. Mauris in erat justo. Nullam ac urna eu felis dapibus
                                    condntum sit amet a augue. Sed non mauris vitae erat consequat auctor eu in elit. Class aptento
                                    taciti sociosqu ad litora torquent.</p>
                            </div>
                        </div>
                    </div>
                    <div className="tab-content ">
                        <div className="item-content">
                            <div className="text-wrap img-right clearfix">
                                <div className="video flat-text-center">
                                    <img src="images/register/video.png" alt="bookflare" />
                                    <a data-type="iframe" href="https://www.youtube.com/embed/2Ge1GGitzLw?autoplay=1"
                                        className=" fancybox"><span className="icon-video" /></a>
                                </div>
                                <h6 className="title">
                                    VOVABULARY
                                </h6>
                                <p className="text">Lorem Ipsn gravida nibh vel velit auctor aliquet. Aenean sollicitudin, lorem
                                    quis bibendum auci elit consequat ipsutis sem nibh id elit. Duis sed odio sit amet nibh
                                    vulputate cursus a sit amet mauris. Morbi accumsan ipsum velit. Nam nec tellus a odio tincidunt
                                    aucto.</p>
                                <h6 className="title mg-bottom-25">
                                    REQUIREMENTS
                                </h6>
                                <p className="text">Per inceptos himenaeos. Mauris in erat justo. Nullam ac urna eu felis dapibus
                                    condntum sit amet a augue. Sed non mauris vitae erat consequat auctor eu in elit. Class aptento
                                    taciti sociosqu ad litora torquent.</p>
                            </div>
                        </div>
                    </div>
                    <div className="tab-content ">
                        <div className="item-content">
                            <div className="text-wrap img-right clearfix">
                                <div className="video flat-text-center">
                                    <img src="images/register/video.png" alt="bookflare" />
                                    <a data-type="iframe" href="https://www.youtube.com/embed/2Ge1GGitzLw?autoplay=1"
                                        className=" fancybox"><span className="icon-video" /></a>
                                </div>
                                <h6 className="title">
                                    KID'S COURSES
                                </h6>
                                <p className="text">Lorem Ipsn gravida nibh vel velit auctor aliquet. Aenean sollicitudin, lorem
                                    quis bibendum auci elit consequat ipsutis sem nibh id elit. Duis sed odio sit amet nibh
                                    vulputate cursus a sit amet mauris. Morbi accumsan ipsum velit. Nam nec tellus a odio tincidunt
                                    aucto.</p>
                                <h6 className="title mg-bottom-25">
                                    REQUIREMENTS
                                </h6>
                                <p className="text">Per inceptos himenaeos. Mauris in erat justo. Nullam ac urna eu felis dapibus
                                    condntum sit amet a augue. Sed non mauris vitae erat consequat auctor eu in elit. Class aptento
                                    taciti sociosqu ad litora torquent.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default TabCourses;